import React, { useEffect, useState, useRef } from "react";

function InlineTextEditor({ onChange, value }) {
  const editorRef = useRef();
  const { CKEditor, ClassicEditor } = editorRef.current || {};
  const [editorLoaded, setEditorLoaded] = useState(false);

  useEffect(() => {
    editorRef.current = {
      CKEditor: require("@ckeditor/ckeditor5-react").CKEditor, // v3+
      ClassicEditor: require("@ckeditor/ckeditor5-build-classic"),
    };
    setEditorLoaded(true);
  }, []);

  const editorConfiguration = {
    toolbar: {
      items: ["bold", "Paragraph", "italic", "|", "link"],
      shouldNotGroupWhenFull: true,
    },
    link: {
      // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
      addTargetToExternalLinks: true,

      // Let the users control the "download" attribute of each link.
      decorators: [
        {
          mode: "manual",
          label: "Downloadable",
          attributes: {
            download: "download",
          },
        },
      ],
      removePlugins: ["image", "uploadimage"],
    },
  };

  if (!editorLoaded) {
    return <div>Loading editor...</div>;
  }

  return (
    <div>
      <CKEditor
        config={editorConfiguration}
        editor={ClassicEditor}
        data={value}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
      />
    </div>
  );
}

export default InlineTextEditor;
